import { useQuery } from "@tanstack/react-query";
import { ApiConfig } from "@/config/api.config";
import { CalendarEventType, CalendarResponseDto } from '@/features/calendar/types/calendar-dto';
import { UrlHelper } from '@/utils/UrlHelper';
import { ApiHookProps } from '@/@types/api.types';
import { DateTimeHelper } from '@/utils/dateTimeHelper';
import {useCurrencyStore} from "@/store/useCurrencyStore.ts";
import { useAxiosAuth } from '@/hooks/useAxiosAuth';

type Props = {
    startDate: Date;
    endDate: Date;
    apartmentId?: string;
    ownerId?: string;
    types?: CalendarEventType[];
} & ApiHookProps;

export const useCalendarApi = ({startDate, endDate, searchText, apartmentId, ownerId, types}: Props) => {
    const axiosInstance = useAxiosAuth();
    const {currentCurrency} = useCurrencyStore();

    const {
        data: calendarEventsListData, 
        isFetching: isFetchingCalendarEventsListData, 
        isError: isErrorCalendarEventsListData,        
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.calendar.queryKeys.list,
            startDate, endDate, searchText, apartmentId, ownerId, types, currentCurrency
        ],
        queryFn: async (): Promise<CalendarResponseDto> => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.calendar.endpoints.list, {
                startDate: DateTimeHelper.getDateOnly(startDate), 
                endDate: DateTimeHelper.getDateOnly(endDate), 
                searchText, apartmentId, ownerId, types
            });
            const { data } = await axiosInstance.get<CalendarResponseDto>(url);
            return data;
        },
    });       

    return {
        calendarEventsListData,
        isFetchingCalendarEventsListData,
        isErrorCalendarEventsListData, 
    }
}